<!-- =========================================================================================
    File Name: MSMessageBox.vue
    Description: Component MsMessageBox - Component hiện thị thông báo
    ----------------------------------------------------------------------------------------
    Author: nntam - 15/8/2019
========================================================================================== -->
<template>
	<div id="message-box">
		<!-- <div id="message-box" > -->
		<div class="con-ms-message-box" v-if="isShowMessage">
			<div class="message-center">
				<div class="ms-message-bg"></div>
				<div
					class="ms-mesage-box"
					:style="[{ width: `${option.widthForm ? option.widthForm : 25}%` }]"
				>
					<div
						class="close-button"
						v-if="option.close"
						@click="btnCloseClick"
					></div>

					<div>
						<div class="padding-20">
							<!-- 'align-items-center': (!showMessageDetail && option.title ==null) -->
							<div class="title" v-if="option.title != null">
								<div
									v-if="option.titleIcon"
									:class="option.titleIcon"
									:style="option.titleIconStyle"
								></div>
								{{ option.title }}
							</div>
							<div :class="{ content: true, 'mr-bottom-20': !option.line }" >
								<div class="icon-message" v-if="option.icon">
									<div class="mi mi-55" :class="[option.icon]"></div>
								</div>
								<div
									class="message-content flex items-center"
									:class="[
										option.component || (!option.icon && option.titleIcon)
											? ''
											: 'p-l-16',
									]"
								>
									<component
										v-if="option.component"
										:is="option.component"
										@linkActive="linkActive_OnClick"
										@linkGuide="linkGuide_OnClick"
									/>
									<span
										v-else-if="option.message"
										id="idMessage"
										class="message"
										v-html="message"
									></span>
									<div
										class="mess-link"
										v-if="
											option.messageDetail !== '' &&
											option.messageDetail != null &&
											!showMessageDetail
										"
										@click="showMessageDetail = true"
									>
										<div class="mi mi-14 mi-chevron-down--primary-small"></div>
										<div>Mở rộng</div>
									</div>
									<span v-if="option.messageDetail !== '' && showMessageDetail">
										&nbsp;{{ option.messageDetail }}
										<div
											class="mess-link"
											v-if="
												option.messageDetail !== '' &&
												option.messageDetail != null &&
												showMessageDetail
											"
											@click="showMessageDetail = false"
										>
											<div class="mi mi-14 mi-chevron-up--primary-small"></div>
											<div>Thu gọn</div>
										</div>
									</span>
								</div>
							</div>
							<div class="mess-line" v-if="option.line"></div>
							<div
								class="mess-footer"
								v-on:keydown="footerKeydown"
								v-if="showButton"
							>
								<!-- nntam - 16/04/2020 thêm computed để bog v-if lồng v-for -->
								<div
									:class="[button.target]"
									v-for="button in listBtn"
									:key="button.key"
								>
									<ms-button
										class="min-width-btn"
										@keydown="escAction"
										:type="button.typeButton"
										:ref="button.focus ? 'btnFocus' : 'btnOther'"
										@click="btnClick(button.key)"
										:title="button.text"
									></ms-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import commonFunc from '@/common/commonFunction';
export default {
	name: 'MsMessageBox',
	props: {
		// chiều rộng của messagebox
		width: {
			type: String,
			default: '444px',
		},
		// option cấu hình messageBox
		option: {
			type: Object,
			default: null,
		},
	},
	computed: {
		listBtn() {
			return this.option.btnConfig.filter((x) => x.hasBtn == true);
		},
	},
	data() {
		let showButton = false;
		for (let i = 0; i < this.option.btnConfig.length; i++) {
			if (this.option.btnConfig[i].hasBtn) {
				showButton = true;
				break;
			}
		}

		return {
			isShowMessage: true,
			showMessageDetail: false,
			message: '',
			showButton: showButton,
		};
	},
	methods: {
		/**
		 * Bắt sự kiện click vào nút X để đóng popup
		 */
		btnCloseClick() {
			this.isShowMessage = false;
			this.$emit('btnClick', this, 'No');
		},
		/**
		 * Bắt sự kiện click vào button
		 */
		btnClick(key) {
			this.isShowMessage = false;
			this.$emit('btnClick', this, key);
		},
		escapeContent(htmlContent) {
			//Thay đổi toàn bộ kí tự đặc biệt `<`, `>` sang ký hiệu tương ứng để không bị ảnh hưởng việc hiển thị html
			return htmlContent.replace(/>/g, '&gt;').replace(/</g, '&lt;');
		},
		escAction(e) {},
		footerKeydown(e) {
			const me = this;
			commonFunc.processUnfocusLastControl(e, function () {
				commonFunc.focusFirstControl(me.$el);
			});
		},
		linkActive_OnClick() {
			this.$emit('linkActive');
			if (this.option.closeMessageAfterLink) {
				this.isShowMessage = false;
			}
		},
		linkGuide_OnClick() {
			this.$emit('linkGuide');
		},
		linkPopup_OnClick() {
			this.$emit('linkPopup');
			this.isShowMessage = false;
		},
	},
	mounted() {
		//Focus
		if (this.$refs['btnFocus']) {
			this.$refs['btnFocus'][0].$el.focus();
		} else {
			let primaryBtn = this.$el.querySelector('.ms-button-primary');
			if (primaryBtn) {
				primaryBtn.focus();
			} else {
				commonFunc.focusFirstControl(this.$el);
			}
		}

		// hiện thị text ra message box
		let tt = document.getElementById('idMessage');
		if (this.option.message != '' && tt != null) {
			// nếu truyền thml thì vẫn để thế còn truyền text thì chuyển lại thành ký từ đặc biệt để nó không bị biến thành html khi hiển thị
			if (
				/<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(
					this.option.message
				)
			) {
				tt.innerHTML = this.option.message;
			} else {
				this.message = this.option.message;
			}
		}

		let linkActive = this.$el.querySelector('.link-active'),
			linkPopup = this.$el.querySelector('.link-open-popup');

		if (linkActive !== null) {
			linkActive.addEventListener('click', this.linkActive_OnClick);
		}
		if (linkPopup !== null) {
			linkPopup.addEventListener('click', this.linkPopup_OnClick);
		}

		let linkGuide = this.$el.querySelector('.link-guide');
		if (linkGuide !== null) {
			linkGuide.addEventListener('click', this.linkGuide_OnClick);
		}
	},
};
</script>

<style lang='scss' scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msMessageBox.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msMessageBox.scss';
}
</style>
